import { RELEASE_VERSION } from '../../lib/releaseVersion';

export function AppFooter() {
  return (
    <footer className="mt-auto border-t border-border/80 pt-3 pb-1 text-center text-[11px] text-muted-foreground sm:text-xs">
      Release <span className="font-mono tabular-nums text-foreground/80">{RELEASE_VERSION}</span>
    </footer>
  );
}
